export default "__VITE_PUBLIC_ASSET__8d30e594__"